function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Text from './Text';
const ErrorText = _ref => {
  let {
    color = 'red',
    ...props
  } = _ref;
  return props.children ? /*#__PURE__*/React.createElement(Text, _extends({
    color: color
  }, props)) : null;
};
ErrorText.propTypes = {};
ErrorText.displayName = 'ErrorText';
export default ErrorText;